import { MOBILE_NAV_HEIGHT, PWA_NAV_SAFE_BOTTOM } from '../../../consts/mobileLayout'

export const BottomNavStyled = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    height: MOBILE_NAV_HEIGHT,

    '& .MuiBottomNavigationAction-root': {
        minWidth: 'auto',
        padding: 0,
        '&.Mui-selected': {
            paddingBottom: "4px",
        },
    },
}

export const bottomNavPwaSx = {
  paddingBottom: PWA_NAV_SAFE_BOTTOM,
  height: `calc(${MOBILE_NAV_HEIGHT} + ${PWA_NAV_SAFE_BOTTOM})`,
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'flex-end',
} as const
